module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-list', {
    class: ("md-triple-line md-dense match-info-list match " + _vm.statusClass)
  }, [_c('md-list-item', {
    on: {
      "click": _vm.onSelect
    }
  }, [_c('div', {
    staticClass: "match-name"
  }, [_vm._v(_vm._s(_vm.match.name))]), _vm._v(" "), _c('div', {
    staticClass: "md-list-item-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.match.description))]), _vm._v(" "), _c('span', {
    staticClass: "match-competitors"
  }, [_vm._v(_vm._s(_vm.competitorsDescription))]), _vm._v(" "), _c('md-tooltip', [_vm._v(_vm._s(_vm.competitorsDescription) + " - " + _vm._s(_vm.match.description) + " - " + _vm._s(_vm.extraInfo(_vm.tournament, _vm.match)))]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.extraInfo(_vm.tournament, _vm.match)))])])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.edit
    }
  }, [_c('md-icon', [_vm._v(_vm._s(_vm.icon(_vm.tournament, _vm.match)))])], 1)], 1)], 1), _vm._v(" "), (_vm.isMine()) ? _c('div', [(_vm.isReady(_vm.tournament, _vm.match)) ? _c('MatchStartDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "match": _vm.match,
      "show": _vm.showMatchActionDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showMatchActionDialog = false
      }
    }
  }) : (_vm.isInProgress(_vm.match)) ? _c('MatchEndDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "match": _vm.match,
      "show": _vm.showMatchActionDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showMatchActionDialog = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('UpdateMatchDialog', {
    attrs: {
      "tournament": _vm.tournament,
      "match": _vm.match,
      "show": _vm.showUpdateMatchDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showUpdateMatchDialog = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-815d5406","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tournamentComponents/match.vue
// module id = 458
// module chunks = 1